module.exports = __webpack_public_path__ + "static/img/logo91.a665e3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo91.png
// module id = KUNQ
// module chunks = 1